module.exports = __webpack_public_path__ + "img/combination_drawings.474bd44.jpg";